"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateTrustOptions = void 0;
const common_1 = require("../../common");
const common_2 = require("../common");
function validateTrustOptions(options) {
    const errors = [];
    errors.push(...common_2.validatePositiveNumber(options.amount, 'amount'));
    errors.push(...common_2.validateEnum(options.paymentMode, 'paymentMode', common_1.PaymentModes));
    return {
        isValid: errors.length === 0,
        errors,
    };
}
exports.validateTrustOptions = validateTrustOptions;
//# sourceMappingURL=trust-options-validator.js.map